import Creator from '@/ts/Creator'
import SOCIAL_MEDIA from '@/views/creator/data/socialMedia'

function SocialMedia({ media }: SocialMediaProps) {
  return (
    <ul className="space-y-3" style={{ gridArea: 'social-media' }}>
      {media.map((media) => (
        <li key={media.id}>
          <a
            href={media.link}
            target="_blank"
            rel="noreferrer"
            className="flex items-center space-x-1 text-sm transition-colors group"
          >
            <span className="block w-4 h-4 text-black group-hover:text-violet-200">
              {SOCIAL_MEDIA[media.platform]}
            </span>
            <span className="text-black/60 group-hover:text-violet-200">
              @{media.nick}
            </span>
          </a>
        </li>
      ))}
    </ul>
  )
}

interface SocialMediaProps {
  media: Creator['social_media']
}

export default SocialMedia
